import React from "react";
import themes from "../../config/theme";

export const ThemeContext = React.createContext(themes.ibft);
